<div>
  <div class="control">
    <label for="select-input-{{ uniqueId }}">
      {{ label }}
      @if (required) {
      <span class="required-indicator has-text-danger">*required</span>
      }
    </label>
    @if (htmlTooltip) {
    <i
      [appHtmlTooltip]="htmlTooltip"
      class="icon icon-info is-size-6 has-text-info ml-1"
    >
    </i>
    } @if (helpText) {
    <p class="help mb-1">{{ helpText }}</p>
    }
    <div class="control">
      <div class="select" [ngClass]="{ 'is-danger': isInvalid }">
        <select
          id="select-input-{{ uniqueId }}"
          class="select"
          (change)="onSelect($event.target.value)"
          [attr.disabled]="readonly"
          #select
        >
          <option value="" selected disabled>
            {{ placeholder || 'Choose an option...' }}
          </option>
          @for (option of selectOptions; track $index) {
          <option
            [value]="option.value"
            [selected]="initialValue === option.value"
            [disabled]="option.disabled"
          >
            {{ option.label }}
          </option>
          }
        </select>
      </div>
    </div>
  </div>
</div>
